'use es6';

import { Record } from 'immutable';
import { AdWordsKeywordTypes } from '../../lib/Constants'; // This is duplicative of AdWordsKeywordEntityRecord, but it would be
// very nice if we could replicate the getter of "name" on that. For now
// they're separate, but we should consolidate on one or the other when we
// get the chance.

export default class AdWordsKeywordReportingEntityRecord extends Record({
  biddingStrategyConfiguration: null,
  id: null,
  accountId: null,
  campaignId: null,
  adGroupId: null,
  keywordText: null,
  matchType: null,
  network: null,
  servingStatus: null,
  status: null,
  type: null,
  previousState: null,
  maxCpc: null,
  topOfPageCpc: null,
  firstPageCpc: null,
  conversionRate: null,
  averagePosition: null,
  qualityScore: null,
  negative: false
}) {
  get name() {
    switch (this.matchType) {
      case AdWordsKeywordTypes.PHRASE:
        return `"${this.keywordText}"`;

      case AdWordsKeywordTypes.EXACT:
        return `[${this.keywordText}]`;

      case AdWordsKeywordTypes.BROAD:
      default:
        return this.keywordText;
    }
  }

}